module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "slider-invisalign-directive",
      rawName: "v-slider-invisalign-directive"
    }],
    staticClass: "slider-invisalign"
  }, _vm._l((_vm.content.slider), function(slide) {
    return _c('div', {
      staticClass: "slider-invisalign__slide",
      style: ({
        backgroundImage: "url(" + slide.pic_link + ")"
      })
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d9b0d9e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/slider/invisalign/slider-invisalign.pug
// module id = 525
// module chunks = 1